// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__bQkkO","rotation":"style_rotation__6G4cs","shine":"style_shine__bmGvY"};